/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['jquery', 'underscore'], ($, _) => {

	const SDK_REQUIRE_CONTEXT = 'Dashboard.VidaSdkUtil';

	// eslint-disable-next-line no-undef
	const rjs = requirejs;

	/**
	 * Deletes the new requirejs context and cleans up any new <script/> tags Require created
	 */
	const cleanupRequireContext = () => {
		delete rjs.s.contexts[SDK_REQUIRE_CONTEXT];
		$(`[data-requirecontext="${SDK_REQUIRE_CONTEXT}"]`).remove();
	};

	return class VidaSdkUtil {

		static isSDKActive(dashboardApi) {
			const visDefinitions = dashboardApi.getFeature('VisDefinitions');
			const visPreview = visDefinitions.getById('visualizationPreview');
			const visualizationPreviewHasBeenLoaded = visPreview && !visPreview.getState().getError();
			let promise;
			if (visualizationPreviewHasBeenLoaded) {
				// The SDK bundle is currently loaded... but the server may not be running any more.
				// This code reloads the manifest.xml to verify the servier is active... or not.
				promise = new Promise((resolve, reject) => {
					require(['com/ibm/vida/control/vida'], vida => {

						// We need a fresh requirejs context here...
						// so we don't go undefining things in the global scope
						const globalRequireConifg = JSON.parse(JSON.stringify(rjs.s.contexts._.config));
						const minimalRequireConfig = {
							context: SDK_REQUIRE_CONTEXT,
							baseUrl: globalRequireConifg.baseUrl,
							urlArgs: `v=${Date.now()}`,
							paths: _.pick(globalRequireConifg.paths, 'text', vida.sdk.bundleLocation)
						};
						const req = require.config(minimalRequireConfig);
						const manifestPath = `text!${vida.sdk.bundleLocation}/manifest.xml`;

						// Require the manifest, and use resolve/reject as success/failure handlers
						req([manifestPath], () => {
							cleanupRequireContext();
							resolve();
						}, (err) => {
							cleanupRequireContext();
							reject(err);
						});

					}, reject);
				});
			} else {
				// The bundle is currently not loaded, attempt to load it.
				promise = Promise.race([
					// Note: This will fail to resolve on IE due to a Mixed/Content error, unless  the user has accepted
					// the browser warning and refreshed the page...
					visDefinitions.loadById('visualizationPreview'),

					// Lets give IE 15 seconds?
					new Promise((resolve, reject) => {
						setTimeout(() => {
							reject(new Error('Failed to load test visualization'));
						}, 15000);
					})
				]);
			}

			return promise.then(() => {
				return true;
			}).catch(() => {
				return false;
			});
		}
	};
});
